<template>
  <div class="member-grade-index">
    <div class="fun-btn-box">
      <auth-button auth="member:config:level:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建等级</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #sortName="{ row }">{{ row.sortName }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #upgradeCondition_show="{ row }">
        <div v-if="row.upgradeCondition_show.length">
          <div v-for="item in row.upgradeCondition_show" :key="item">{{ item }}</div>
        </div>
        <div v-else>---</div>
      </template>
      <template #relegateCondition_show="{ row }">
        <div v-if="row.relegateCondition_show.length">
          <div v-for="item in row.relegateCondition_show" :key="item">{{ item }}</div>
        </div>
        <div v-else>---</div>
      </template>
      <template #background="{ row }">
        <img class="bkurl" :src="row.background" alt="" srcset="">
      </template>
      <template #logo="{ row }">
        <img class="logo" :src="row.logo" alt="" srcset="">
      </template>
      <template #privilegeNames="{ row }">{{ row.privilegeNames.length > 0 ? row.privilegeNames.join(',') : '---' }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY-MM-DD HH:mm:ss') : '---' }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="onExport(scope.row)">导出会员</el-button> -->
        <auth-button auth="member:config:level:update">
          <el-button type="text" @click="onEdit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="member:config:level:delete">
          <el-button type="text" class="error ml10" @click="onDelete(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getListLevel, api_deleteMemberLevel } from '@/api/member'
import Table from "@/components/Table/index"
import tableList from '@/mixins/tableList'
export default {
  name: "memberGradeIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Table,
  },
  data() {
    return {
      form: {},
      tableThData: [
        { prop: "sortName", label: "会员等级", minWidth: "100", },
        { prop: "name", label: "等级名称", minWidth: "120", },
        { prop: "upgradeCondition_show", label: "升级条件", minWidth: "220", },
        { prop: "relegateCondition_show", label: "保级条件", minWidth: "240", },
        { prop: "background", label: "等级背景", minWidth: "180", },
        { prop: "logo", label: "等级LOGO", minWidth: "120", },
        { prop: "privilegeNames", label: "会员权益", minWidth: "230", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "180", },
      ],
      conditionRange: {
        greaterAndEquals: '大于等于',
        equals: '等于',
        greater: '大于',
      },
      upgradeRender: [
        {amount: '日消费金额', point: '日获取积分', paramsName: 'daily'},
        {amount: '或月消费金额', point: '或月获取积分' , paramsName: 'monthly'},
        {amount: '或年消费金额', point: '或年获取积分' , paramsName: 'annually'},
      ],
      relegateRender: [
        {naturalYear: '自然年度消费金额', upgradeDate: '365日内消费金额', paramsName: 'amount'},
        {naturalYear: '或自然年度积分获取', upgradeDate: '或365日内获取积分', paramsName: 'point'},
      ],
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getListLevel(params)
      let list = this.handleCondition(data.list)
      this.tableTrData = list || []
      this.total = data.count
      this.loading = false
    },

    // 处理升级保级条件展示
    handleCondition(list) {
      let result = list.map(item => {
        item.upgradeCondition = item.upgradeCondition ? JSON.parse(item.upgradeCondition) : {}
        item.upgradeCondition.condition = Object.keys(item.upgradeCondition)[0] || ''
        item.upgradeCondition_show = []
        this.upgradeRender.forEach(element => {
          if (item.upgradeCondition.condition) {
            let curValue = item.upgradeCondition[item.upgradeCondition.condition][element.paramsName]
            if (curValue.rangeCond) {
              let str = element[item.upgradeCondition.condition] + this.conditionRange[curValue.rangeCond] + curValue.begin + '升级'
              item.upgradeCondition_show.push(str)
            }
          }
        })
        item.relegateCondition = item.relegateCondition ? JSON.parse(item.relegateCondition) : {}
        item.relegateCondition.condition = Object.keys(item.relegateCondition)[0] || ''
        item.relegateCondition_show = []
        this.relegateRender.forEach(element => {
          if (item.relegateCondition.condition) {
            let curValue = item.relegateCondition[item.relegateCondition.condition][element.paramsName]
            if (curValue.rangeCond && curValue.begin) {
              let str = element[item.relegateCondition.condition] + this.conditionRange[curValue.rangeCond] + curValue.begin + '保级'
              item.relegateCondition_show.push(str)
            }
          }
        })
        return item
      })
      console.log('result: ', result);
      return result
    },

    // 点击新增按钮
    onAdd() {
      this.$router.push('/member/grade/add');
    },
    // 点击导出会员按钮
    onExport(row) {

    },
    // 点击编辑按钮
    onEdit(row) {
      this.$router.push(`/member/grade/add?id=${row.id}`);
    },
    // 点击删除按钮
    onDelete(row) {
      this.$baseConfirm(
        '是否确认删除？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deleteMemberLevel({id: row.id})
          this.$baseMessage('删除成功', 'success')
          this.getList()
        }
      )
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.member-grade-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .bkurl{
    width: 120px;
    height: 56px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
  .logo{
    width: 46px;
    height: 46px;
    border-radius: 50%;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
